// Bloque C: horas en la zona horaria de la aerolínea (no la del navegador)
const offsetMin = (date, tz) => {
    const d = new Date(date);
    return (Date.parse(d.toLocaleString('en-US', { timeZone: tz })) - Date.parse(d.toLocaleString('en-US', { timeZone: 'UTC' }))) / 60000;
};

export const toTenantInput = (iso, tz) => {
    if (!iso) return '';
    const s = new Intl.DateTimeFormat('sv-SE', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(iso));
    return s.replace(' ', 'T').slice(0, 16);
};

export const fromTenantInput = (local, tz) => {
    const guess = Date.parse(`${local}:00Z`);
    return new Date(guess - offsetMin(guess, tz) * 60000).toISOString();
};

export const fmtTenant = (iso, tz) => (iso ? toTenantInput(iso, tz).replace('T', ' ') : '—');

export const fmtDay = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString('es', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' }) : '');
